export const APP_NAME = "Calibrate";
export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000/";
// Optional dedicated WebSocket base URL (e.g. wss://ws.dev.calibrate.gmind.dev).
// When empty, the WS client derives the URL from API_URL (local/prod default).
export const WS_URL = process.env.REACT_APP_WS_URL || "";
export const PRIVACY_POLICY_URL = "https://calibratehcm.com/privacy-policy";
export const TERMS_OF_SERVICE_URL =
  "https://calibratehcm.com/terms-and-conditions";

export const LOGO_URL = "/images/logo.png";

export const CHCM_LOGO_MARK_WHITE_URL = "/branding/chcm-logo-mark-white.svg";

export const TOP_BAR_LOGO_HEIGHT_PX = 52;

export {
  SHELL_TOP_BAR_PX,
  SHELL_FOOTER_PX,
  SHELL_SIDEBAR_WIDTH_PX,
  SHELL_NAV_ROW_HEIGHT_PX,
  SHELL_NAV_GAP_PX,
  SHELL_NAV_ROW_INNER_SPACING,
  SHELL_NAV_ROW_HEIGHT_SHORT_PX,
  SHELL_NAV_ROW_MIN_TOUCH_PX,
  POINTER_COARSE_MEDIA,
  SHELL_MAIN_CHROME_PADDING_PX,
  TABLE_PAGE_CONTAINER_HEIGHT,
  VIEWPORT_2K_MIN_MEDIA,
  VIEWPORT_2K_MIN_WIDTH_MATCH,
  VIEWPORT_2K_MIN_WIDTH_PX,
  SHELL_SIDEBAR_WIDTH_2K_PX,
  SHELL_NAV_ROW_HEIGHT_2K_PX,
  VIEWPORT_4K_MIN_MEDIA,
  VIEWPORT_4K_MIN_WIDTH_MATCH,
  VIEWPORT_4K_MIN_WIDTH_PX,
  SHELL_SIDEBAR_WIDTH_4K_PX,
  SHELL_NAV_ROW_HEIGHT_4K_PX,
  VIEWPORT_COMPACT_MAX_MEDIA,
  VIEWPORT_COMPACT_MAX_WIDTH_MATCH,
  VIEWPORT_COMPACT_MAX_WIDTH_PX,
  VIEWPORT_SHORT_MAX_MEDIA,
  VIEWPORT_SHORT_MAX_HEIGHT_MATCH,
  VIEWPORT_SHORT_MAX_HEIGHT_PX,
  SHELL_VIEWPORT_HEIGHT_SX,
  viewportCappedHeightSx,
  PHONE_LANDSCAPE_MATCH,
  PHONE_LANDSCAPE_MEDIA,
} from "./layout";
